/*(function(){
  const numeroWhatsApp = '5519999173599'; 

  function montarMensagem(card){
    const title = (card.querySelector('.card__heading a')?.textContent || 'Produto').trim();
    const url   = new URL(card.querySelector('.card__heading a')?.getAttribute('href') || '/', location.origin).href;
    const sale  = card.querySelector('.price .price-item--sale')?.textContent?.trim();
    const reg   = card.querySelector('.price .price-item--regular')?.textContent?.trim();
    const price = sale || reg || 'Consultar';
    return `Olá! Tenho interesse em ${title} por ${price}. Pode me ajudar? ${url}`;
  }

  function criarBotao(msg){
    const a = document.createElement('a');
    a.className = 'btn btn--full btn--whatsapp';
    a.target = '_blank';
    a.rel = 'noopener';
    a.href = `https://api.whatsapp.com/send?phone=${numeroWhatsApp}&text=${encodeURIComponent(msg)}`;
    a.textContent = 'Compre por WhatsApp';
    a.style.cssText = `
      background-color:#25D366;color:#fff!important;border:none;margin-top:15px;
      padding:10px 20px;text-align:center;display:block;font-weight:bold;
      text-decoration:none;border-radius:10px;
    `;
    return a;
  }

  function inserir(card){
    if (card.dataset.whatsInjected === '1') return;
    const priceBlock = card.querySelector('.card__information .wbhprice, .card__information .price');
    if (!priceBlock) return;
    const msg = montarMensagem(card);
    const btn = criarBotao(msg);
    priceBlock.insertAdjacentElement('afterend', btn);
    card.dataset.whatsInjected = '1';
  }

  function scan(){
    document.querySelectorAll('.card.card--standard').forEach(inserir);
  }

  new MutationObserver(()=>scan()).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded', scan);
})();*/(function(){
  function criarBotaoVerOpcoes(card){
    // Busca o link original do produto no card
    const productLink = card.querySelector('.card__heading a')?.getAttribute('href') || '#';
    
    const a = document.createElement('a');
    a.className = 'btn btn--full btn--ver-opcoes';
    a.href = productLink;
    a.textContent = 'Ver Opções';
    
    // Estilização: Botão preto, arredondado e ocupando a largura total
    a.style.cssText = `
      background-color: #000;
      color: #fff !important;
      border: none;
      margin-top: 15px;
      padding: 12px 20px;
      text-align: center;
      display: block;
      font-weight: bold;
      text-decoration: none;
      border-radius: 10px;
      text-transform: uppercase;
      font-size: 13px;
      transition: opacity 0.2s;
    `;
    
    // Efeito de hover simples
    a.onmouseover = () => a.style.opacity = '0.8';
    a.onmouseout = () => a.style.opacity = '1';
    
    return a;
  }

  function inserir(card){
    // Evita duplicados
    if (card.dataset.optionsInjected === '1') return;
    
    // Localiza o bloco de preço para inserir o botão logo abaixo
    const priceBlock = card.querySelector('.card__information .wbhprice, .card__information .price');
    if (!priceBlock) return;
    
    const btn = criarBotaoVerOpcoes(card);
    priceBlock.insertAdjacentElement('afterend', btn);
    
    card.dataset.optionsInjected = '1';
  }

  function scan(){
    // Seleciona os cards (ajustado para o padrão Dawn/OS 2.0)
    document.querySelectorAll('.card.card--standard, .card.card--card').forEach(inserir);
  }

  // Observa mudanças na página (filtros, paginação infinita)
  new MutationObserver(() => scan()).observe(document.body, { childList: true, subtree: true });
  
  // Executa ao carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();